import { render, staticRenderFns } from "./cgm-dashboard.vue?vue&type=template&id=71201e73&scoped=true&"
import script from "./cgm-dashboard.vue?vue&type=script&lang=js&"
export * from "./cgm-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./cgm-dashboard.vue?vue&type=style&index=0&id=71201e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71201e73",
  null
  
)

export default component.exports